import React from "react";
import CssClasses from "./TicketPairItem.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";
import Auxx from "../../../HOCs/AUXX/Auxx";

const TicketPairItem = props => {
  let oddsAnim = "";

  if (props.changeDirection > 0) {
    oddsAnim = CssClasses.increasedOdds;
  } else if (props.changeDirection < 0) {
    oddsAnim = CssClasses.decreasedOdds;
  }

  return (
    <div
      className={[
        CssClasses.container,
        props.checked ? "" : CssClasses.inactive,
        props.paused ? CssClasses.paused : "",
        props.isFix && props.checked ? CssClasses.fixActiveRow : "" //ne smije bit odcekiran!
      ].join(" ")}
    >
      <label className={CssClasses.chkboxContainer}>
        <input
          type="checkbox"
          checked={props.checked}
          onChange={ev => {
            props.onCheckChanged(props.matchID, ev);
          }}
        />
        <span className={CssClasses.checkmark} />
      </label>
      <span className={CssClasses.matchTitle}>{props.matchName}</span>
      <span
        onClick={() => {
          props.onRemovePair(props.matchID);
        }}
        className={[SiteIcons.site_icon_close, CssClasses.btnRemove].join(" ")}
      />
      <div className={CssClasses.clearFix} />
      <hr className={CssClasses.separator} />

      {/* ako treba, ubaci i fix gumb */}
      {props.isForSystem ? (
        <Auxx>
          <div
            onClick={() => {
              props.onToggleFix(props.matchID);
            }}
            className={[
              CssClasses.btnFix,
              props.isFix ? CssClasses.btnFixActive : ""
            ].join(" ")}
          >
            FIX
          </div>

          {/* {props.isFix || props.systemLegend === "" ? null : (
            <div className={CssClasses.systemIndicator}>
              {props.systemLegend}
            </div>
          )} */}

          {/* <div className={CssClasses.clearFix} /> */}
        </Auxx>
      ) : null}

      <span className={CssClasses.betInfo}>{props.betName}</span>
      <span className={CssClasses.betInfo}>Tip: {props.pick}</span>
      <span className={[CssClasses.oddIndicator, oddsAnim].join(" ")}>
        {props.odds}
      </span>

      {props.isLive ? (
        <span
          className={[
            CssClasses.liveIndicator,
            //CssClasses.flickers,
            props.isForSystem ? CssClasses.liveDuringSystem : ""
          ].join(" ")}
        >
          LIVE
        </span>
      ) : null}

      <div className={CssClasses.clearFix} />
    </div>
  );
};

export default TicketPairItem;



// WEBPACK FOOTER //
// ./src/Components/UI/TicketPairItem/TicketPairItem.js